import styled from "styled-components";

/**
 * Container do campo de pesquisa
 * Configuração geral do layout do campo.
 */
export const FieldSearch = styled.div`
  padding: ${({ theme }) => theme.spacing(2)}
    ${({ theme }) => theme.spacing(0.5)} ${({ theme }) => theme.spacing(2)}
    ${({ theme }) => theme.spacing(1)};
  gap: ${({ theme }) => theme.spacing(0.5)};
  align-items: center;
  position: relative;
  display: flex;

  & > svg {
    height: ${({ theme }) => theme.spacing(4.5)};
    width: ${({ theme }) => theme.spacing(4.5)};

    &:first-child {
      margin-top: -7.5px;
    }
  }

  /* Se a classe 'disabled' estiver presente */
  &.disabled {
    pointer-events: none; /* Impede interações */
    opacity: 0.22;
  }
`;
